import { plural } from '@cian/utils';

import { NBSP } from 'shared/constants/text';
import { formatNumber, noBreak } from 'shared/utils/format';
import type { IBuildingBlock, IBuildingBlockOffers } from 'shared/types/buildingOffers';

export interface IBlockOffersView {
  title: 'Аренда' | 'Продажа';
  area: string;
  link: { url: string; text: string } | null;
}

/** Площадь корпуса округляется до целого (`render_number` презентера монолита) */
const formatRoundedArea = (value: number): string => noBreak(formatNumber(value));

/** Колонка корпуса «Аренда» / «Продажа» — только при минимальной площади (`object_corps.tsx` монолита) */
function getColumn(title: IBlockOffersView['title'], offers: IBuildingBlockOffers): IBlockOffersView | null {
  const { minArea, maxArea, count, link } = offers;

  if (!minArea) {
    return null;
  }

  // Без максимума — одна площадь (в монолите вышло бы «от X до  м²»)
  const area =
    maxArea && maxArea !== minArea
      ? `от ${formatRoundedArea(minArea)} до ${formatRoundedArea(maxArea)}${NBSP}м²`
      : `${formatRoundedArea(minArea)}${NBSP}м²`;

  return {
    title,
    area,
    link:
      link && count !== null
        ? { url: link, text: `${count}${NBSP}${plural(count, ['помещение', 'помещения', 'помещений'])}` }
        : null,
  };
}

export const getBlockOffers = ({ rent, sale }: IBuildingBlock): IBlockOffersView[] =>
  [getColumn('Аренда', rent), getColumn('Продажа', sale)].filter(
    (column): column is IBlockOffersView => column !== null,
  );
